import React from "react";
import * as Icons from "../../assets/svgs/icons";

type IconName = keyof typeof Icons;

export interface IconBtnProps
  extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, "style"> {
  size?: "x-lg" | "lg" | "md" | "sm" | "x-sm";
  style?: "ghost" | "fill"; // rename to avoid confusion with native style prop
  icon?: IconName;
  fill?: string;
}

const sizeMap = {
  "x-lg": "size-[60px] p-[18px]",
  lg: "size-[56px] p-[16px]",
  md: "size-[48px] p-[12px]",
  sm: "size-[44px] p-[10px]",
  "x-sm": "size-[40px] p-[10px]",
};

const iconSizeMap = {
  "x-lg": 24,
  lg: 24,
  md: 24,
  sm: 24,
  "x-sm": 20,
};

const Icon: React.FC<IconBtnProps> = ({
  size = "x-lg",
  style = "ghost",
  icon,
  className,
  fill,
  ...props
}) => {
  const base =
    "flex items-center justify-center gap-[10px] transition-all duration-200 box-border content-stretch";
  const sizeClass = sizeMap[size];
  const iconSize = iconSizeMap[size];

  let styleClass = "rounded-[40px] ";
  if (style === "fill") {
    styleClass += "bg-[#6d2ef2] px-[16px] py-0 hover:bg-[#5e2bc8]";
  } else {
    styleClass += "hover:bg-[#f3e8ff]";
  }

  const IconComponent = icon ? Icons[icon] : null;

  return (
    <button
      className={`${base} ${sizeClass} ${styleClass} ${className || ""}`}
      type="button"
      {...props}
    >
      <span
        style={{ width: iconSize, height: iconSize, display: "inline-flex" }}
        className="overflow-clip relative shrink-0"
      >
        {IconComponent && (
          <IconComponent width={iconSize} height={iconSize} fill={fill} />
        )}
      </span>
    </button>
  );
};

export default Icon;
